import * as i from "react";
import { P as o } from "./index.DMLWxr4u.js";
import { j as t } from "./jsx-runtime.DGlMoOmv.js";
var s = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), d = "VisuallyHidden", a = i.forwardRef(
  (r, e) => /* @__PURE__ */ t.jsx(
    o.span,
    {
      ...r,
      ref: e,
      style: { ...s, ...r.style }
    }
  )
);
a.displayName = d;
var n = a;
export {
  n as R,
  a as V,
  s as a
};
//# sourceMappingURL=index.BkBvp-m6.js.map
